import { z } from 'zod';
import { BaseAddressDTOSchema, } from "./addresses.dto.js";
// API layer DTOs (if needed for direct address lookup endpoints)
export const FindAddressByIdRequestDTOSchema = z.object({
    params: z.object({
        addressId: BaseAddressDTOSchema.shape.id,
    }),
});
//# sourceMappingURL=find-address-by-id.dto.js.map